<template>
  <NuxtErrorBoundary @error="onError">
    <!-- Google Tag Manager (noscript) -->
    <noscript v-for="containerId in gtmIds" :key="containerId"
      ><iframe
        :src="`https://www.googletagmanager.com/ns.html?id=${containerId}`"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe
    ></noscript>
    <!-- End Google Tag Manager (noscript) -->
    <NuxtLayout>
      <Loading />
      <NuxtPage />
      <VueQueryDevtools />
    </NuxtLayout>
  </NuxtErrorBoundary>
</template>

<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';

const config = useRuntimeConfig();
const gtmIds = [
  'GTM-N33LXXSH',
  config.public.gtagId,
  config.public.gtagExtraId,
].filter(
  (id, index, ids): id is string => Boolean(id) && ids.indexOf(id) === index,
);

useHead({
  script: gtmIds.map((containerId) => ({
    children: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${containerId}');`,
    type: 'text/javascript',
  })),
});

const { $sentryCaptureException } = useNuxtApp();

const onError = (error: any) => {
  console.error(error);
  $sentryCaptureException(error);
  showError(error);
};
</script>
